// For the few places that build HTML strings for v-html out of user-entered text (names, group
// names, search terms): escape it first so it can't inject markup or scripts.

const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);
}

// A search term as a literal pattern, so "(" or "[" don't break new RegExp().
export function escapeRegExp(value) {
  return String(value ?? '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Wraps each case-insensitive match of query in `before`/`after`, with all text escaped.
// Matches against the original text, so entities like "&amp;" are never split.
export function highlightMatches(text, query, before, after) {
  const raw = String(text ?? '');
  if (!query) return escapeHtml(raw);
  // The capture group keeps the matches in split()'s result, at the odd indexes.
  return raw
    .split(new RegExp(`(${escapeRegExp(query)})`, 'gi'))
    .map((part, index) => (index % 2 ? `${before}${escapeHtml(part)}${after}` : escapeHtml(part)))
    .join('');
}
